<template>
    <div class="wlx-meet-signUp-wrapper wlx-meet-register-main">
        <div class="new-center-content">
            <div class="wl-certification-content">
                <div class="authen-hade-title clearfix">
                    <h3 class="h3-text-title fl">
                        <span>会议报名</span>
                    </h3>
                    <div class="authen-hade-crumbs fr">
                        <i class="wl-icon-zhuye1"></i>
                        <span>当前位置：</span>
                        <span @click="goHome">网站首页</span>
                        <span class="sp-line-home">></span>
                        <span>会议报名</span>
                    </div>
                </div>
                <div class="border-class-content">
                    <div class="new-center-list clearfix" v-for="(item, index) in meetList" :key="index">
                        <div class="new-center-li clearfix" @click="getMeetDetail(item.id)">
                            <div class="li-back-date">
                                <p class="date-class">{{ item.day }}</p>
                                <p>{{ item.month }}</p>
                            </div>
                            <div class="new-center-left">
                                <p class="text-title">{{ item.title }}</p>
                                <p>
                                    <span class="sp-time-label">报名起止时间:</span><span class="p-meeet-end-time"> {{ item.startTime }} ~ {{ item.endTime }}</span>
                                </p>
                                <p class="text-detail" v-html="item.contentText"></p>
                            </div>
                        </div>
                    </div>
                    <div v-if="meetList.length == 0" class="no-meet-tip">
                        暂无会议!
                    </div>
                    <div class="el-block-pagination" v-if="meetList.length > 0">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4" :page-sizes="[10, 20, 40, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div class="ph-new-center-content">
            <div class="wl-certification-content">
                <div class="authen-hade-crumbs">
                    <div style="padding:0 20px;">
                        <i class="wl-icon-zhuye1"></i>
                        <span @click="goHome">首页</span>
                        <span class="sp-line-home">></span>
                        <span>会议报名</span>
                    </div>
                </div>
                <!-- <div class="authen-hade-title clearfix">
          <h3 class="h3-text-title fl">
            <span>会议报名</span>
          </h3>
        </div> -->
                <v-refresh :on-refresh="onRefresh">
                    <v-reload :on-infinite-load="onInfiniteLoad" :parent-pull-up-state="infiniteLoadData.pullUpState">
                        <div class="border-class-content">
                            <div class="new-center-list clearfix" v-for="(item, index) in phmeetList" :key="index">
                                <div class="new-center-li clearfix" @click="getMeetDetail(item.id)">
                                    <div class="li-back-date">
                                        <p class="date-class">{{ item.day }}</p>
                                        <p>{{ item.month }}</p>
                                    </div>
                                    <div class="new-center-left">
                                        <p class="text-title">{{ item.title }}</p>
                                        <p>
                                            <span class="sp-time-label">截止时间:</span><span class="p-meeet-end-time"> {{ item.endTime }}</span>
                                        </p>
                                        <p class="text-detail" v-html="item.contentText"></p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="meetList.length == 0" class="no-meet-tip">
                                暂无会议!
                            </div>
                        </div>
                    </v-reload>
                </v-refresh>
            </div>
        </div>
    </div>
</template>

<script>
import downFresh from "components/refreshData/downFresh.vue";
import pullUpReload from "components/refreshData/pullUpReload.vue";
export default {
    data() {
        return {
            isTab: 1,
            back: require("assets/images/bg-jieshao.png"),
            TeaAuthenticaList: [],
            pageSize: 10,
            type: 1,
            totalCount: 0,
            currentPage4: 1,
            meetList: [],
            phmeetList: [],
            infiniteLoadData: {
                initialShowNum: 3, // 初始显示多少条
                everyLoadingNum: 3, // 每次加载的个数
                pullUpState: 0, // 子组件的pullUpState状态
                pullUpList: [], // 上拉加载更多数据的数组
                showPullUpListLength: this.initialShowNum, // 上拉加载后所展示的个数
            },
        };
    },
    components: {
        "v-refresh": downFresh,
        "v-reload": pullUpReload,
    },
    created() {
        this.getMeetList(1);
    },
    computed: {
        association: function() {
            return this.$store.state.association;
        },
    },
    methods: {
        onRefresh(done) {
            this.phmeetList = [];
            this.getMeetList();
            done();
        },
        onInfiniteLoad(done) {
            this.getMeetList();
            done();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getMeetList(1);
        },
        handleCurrentChange(val) {
            this.getMeetList(val);
        },
        goHome() {
            this.$router.push({
                name: "xHome",
            });
        },
        getMeetList(page) {
            this.$http
                .post("/api/XOrg/Special/getSpecialList", {
                    associationId: this.association.Id,
                    type: 1,
                    pageSize: this.pageSize,
                    page,
                })
                .then((res) => {
                    if (res.code > 0) {
                        this.meetList = res.list;
                        this.phmeetList = res.list;
                        this.pageSize = res.pagination.pageSize;
                        this.totalCount = res.pagination.totalCount;
                        console.log(this.infiniteLoadData.pullUpState);
                        if (this.phmeetList.length == this.totalCount) {
                            this.infiniteLoadData.pullUpState = 3;
                        }
                    }
                });
        },
        getMeetDetail(id) {
            this.$router.push({
                name: "meetSignUpDetail",
                params: {
                    meetId: id,
                },
            });
        },
    },
};
</script>
<style lang="scss">
.wlx-meet-register-main {
    .new-center-content {
        margin: 0 auto;
        width: 1200px;
        .new-center-list {
            padding: 0 0 30px 0;
        }
        .authen-hade-title {
            border-bottom: 2px solid #e9ebf0;
            .h3-text-title {
                float: left;
                font-size: 20px;
                font-weight: 400;
                line-height: 40px;
                border-bottom: 2px solid #2d82ff;
                position: relative;
                bottom: -2px;
            }
            .authen-hade-crumbs {
                font-size: 14px;
                line-height: 40px;
                color: #a4a4a4;
            }
            .sp-line-home {
                margin: 0 5px;
            }
        }
        .el-block-pagination {
            padding: 20px 0 30px 0;
        }
        .sp-time-label {
            margin-bottom: 10px;
            font-size: 14px;
            margin-right: 10px;
        }
        .p-meeet-end-time {
            margin-bottom: 10px;
            color: #ec5252;
            font-size: 14px;
        }
    }
}
</style>
